module.exports = __webpack_public_path__ + "static/media/olivia-selector.6349354b.png";